import Analyzer from './analyzer'
import Command from './command'
import Common from './common'
import Logger from './logger'
import Scheduler from './scheduler'

// initialize name-space using the global variable defined in Analyzer
// fallback to 'adavada' for safe measure
const namespace = (Analyzer && Analyzer.WINDOW_NAMESPACE) || 'adavada'

// caller interface with scheduler, results are returned in form of promise
let caller = () => null
// client interface directly with executors, results are return synchronously
let client = () => null

try {
  Logger.info('index.js - pre-initialization')

  // it is possible that a lightweight shell has been created,
  // and has captured the commands that have not been executed.
  let uninitialized = window[Analyzer.WINDOW_NAMESPACE]
  if (uninitialized) {
    Logger.info('index.js - process items in the initial queue')
    Logger.info('index.js - uninitialized.queue:', uninitialized.queue)
    Scheduler.initQueue(Command.parseQueue(uninitialized.queue || []))
  }

  Logger.info('index.js - start the scheduler')
  Scheduler.start()

  caller = function() {
    var command = Command.parse(...arguments)
    return command.isValid ? Scheduler.schedule(command) : null
  }
  client = function() {
    var command = Command.parse(...arguments)
    return command.isValid ? command.execute() : null
  }

  // exposes logs and static methods to the global object as well
  caller.logs = Logger.getLogs()
  caller.warnings = Logger.getWarnings()
  caller.extractValue = Common.extractValue
  caller.generateIdByURL = Common.generateIdByURL

  Logger.info('index.js - expose caller to window object')
  caller.client = client

  caller.initialized = true
  window[namespace] = caller
} catch (error) {
  Logger.info('index.js - error encountered at initialization: ' + error)
  caller.error = error
}
